import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { layout } from 'styled-system';
import { Box } from "../../../box/src";
import { responsive, useMatchBreakpoint } from "../../../theme/src";
export const Picture = ({ coverPictureUrl, showContent = false, }) => {
    const isNotBreakpointM = useMatchBreakpoint(['s', 'l', 'xl']);
    return (_jsx(PictureRoot, { "$isNotBreakpointM": isNotBreakpointM, "$showContent": showContent, dataTestId: "appheader-picture", flexDirection: "column", children: _jsx(StaticCoverPicture, { "$showContent": showContent, alt: "", "data-testid": "appheader-cover-picture", src: coverPictureUrl }) }));
};
const PictureRoot = styled(Box).attrs(({ $isNotBreakpointM, $showContent }) => ({
    justifyContent: $isNotBreakpointM ? 'end' : 'center',
    minWidth: {
        l: 470,
        m: 290,
        xl: 676,
    },
    ml: $showContent
        ? {
            l: 6,
            m: 5,
        }
        : 0,
})) ``;
const StaticCoverPicture = styled.img.attrs(({ $showContent }) => ({
    height: {
        l: $showContent ? 216 : 260,
        m: $showContent ? 187 : 196,
        xl: $showContent ? 310 : 374,
    },
    width: $showContent
        ? {
            l: 470,
            m: 290,
            xl: 676,
        }
        : '100%',
})) `
  ${layout}
  object-fit: cover;
  ${({ theme }) => {
    const radius = `${theme.themeVariables.globalBorderRadius}px`;
    return responsive('m') `
    border-radius: ${radius};
`;
}}
`;
//# sourceMappingURL=Picture.js.map